// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-inner-container {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  background-color: white;
  border-radius: 10px;
  padding: 15px 0;
  margin-top: 10px;
  gap: 20px;
  flex: 1 1;
}
.grid-inner-container .list-items-text {
  font-weight: 700;
  font-size: 18px;
}
.grid-inner-container .list-items {
  padding-top: 0px;
}
.grid-inner-container .list-items .list-item-container {
  display: flex;
  flex-direction: row;
  gap: 5px;
}
.grid-inner-container .list-items .list-item-container .title {
  color: #040b1e;
  font-weight: 700;
  font-size: 18px;
}
@media (max-width: 1024px) {
  .grid-inner-container .list-items .list-item-container {
    flex-direction: column;
  }
}
.grid-inner-container .css-1p823my-MuiListItem-root {
  height: 31px;
}
@media (max-width: 1366px) and (min-width: 1200px) {
  .grid-inner-container .css-1p823my-MuiListItem-root {
    height: 24px;
  }
}
@media (max-width: 1024px) {
  .grid-inner-container .css-1p823my-MuiListItem-root {
    height: 48px;
  }
}

.profilePic-dashboard-container {
  width: 70px;
  height: 70px;
  overflow: hidden;
  border-radius: 50%;
}
.profilePic-dashboard-container .profilePic-dashboard {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.MuiAutocomplete-hasPopupIcon.css-1wuilmg-MuiAutocomplete-root .MuiOutlinedInput-root {
  height: 36px;
  margin-left: 1px;
  background-color: #003478;
  color: white;
  text-align: center;
  margin-bottom: 5px;
}

.css-1glvl0p-MuiButtonBase-root-MuiIconButton-root-MuiAutocomplete-clearIndicator {
  display: none;
}

.main-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 0 auto;
  background-color: #fff;
  width: 100%;
  max-width: 1400px;
  min-width: 0;
  box-sizing: border-box;
}

.content-container {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: calc(100vh - 74px);
  margin-top: 74px;
  background-color: #fff;
  box-sizing: border-box;
  overflow-x: hidden;
}

.dashboard-sidebar-slot {
  width: 18%;
  flex: 0 0 18%;
  background-color: #040b1e;
  align-self: stretch;
}

.dashboard-page {
  width: 82%;
  flex: 1 1 auto;
  min-width: 0;
  padding: 16px 20px 40px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
}

@media (max-width: 1024px) {
  .dashboard-sidebar-slot {
    width: 28%;
    flex-basis: 28%;
  }
  .dashboard-page {
    width: 72%;
    padding: 12px 12px 32px;
  }
}
@media (max-width: 600px) {
  .dashboard-sidebar-slot {
    width: 180px;
    flex-basis: 180px;
  }
  .dashboard-page {
    width: calc(100% - 180px);
    padding: 12px 10px 28px;
  }
}
.first-grid {
  background-color: #ededed;
  height: auto;
  padding: 20px;
  width: 100%;
  margin: 10px auto;
  border-radius: 15px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  align-items: stretch;
  box-sizing: border-box;
}
@media (max-width: 1200px) {
  .first-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}
.first-grid .first-grid-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  min-width: 0;
  height: 100%;
}
.first-grid .first-grid-container > .grid-inner-container {
  margin-top: auto;
}
.first-grid .first-grid-container .list-items-container .list-items {
  border-radius: 10px;
}
.first-grid .grid-inner-other {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  min-width: 0;
  height: 100%;
}
.first-grid .grid-inner-other .list-items-container {
  width: 100%;
  display: flex;
  align-items: end;
  justify-content: center;
}
.first-grid .grid-inner-other .list-items-container .box-container .list-items .title {
  color: #040b1e;
  font-weight: 700;
  font-size: 18px;
}
.first-grid .grid-inner-other .list-items-container .box-container .list-items .list-item-container {
  display: flex;
  gap: 5px;
}

.second-grid {
  height: auto !important;
  width: 100% !important;
  max-width: 100%;
  justify-content: space-around;
  align-items: center;
  margin: 24px auto !important;
  border-radius: 15px;
  box-sizing: border-box;
}
.second-grid .sales-year-title {
  margin-top: 0 !important;
}
.second-grid .sales-year-title h2 {
  margin: 0;
  font-size: clamp(18px, 2vw, 24px);
}
.second-grid .dropdown-container {
  display: flex !important;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  width: 100% !important;
  margin: 0 !important;
}
.second-grid .dropdown-container > .MuiGrid-item {
  flex: 1 1 220px;
  max-width: 100%;
  min-width: 0;
  margin-top: 0 !important;
}
.second-grid .stat-callout {
  display: inline-block;
  width: min(220px, 100%);
  max-width: 100%;
  padding-left: 16px;
  box-sizing: border-box;
}
.second-grid .stat-callout-value {
  padding-left: 16px;
  margin-top: 0;
  margin-bottom: 0;
  word-break: break-word;
}
.second-grid .barChart-container {
  height: auto !important;
  width: 100% !important;
  flex-direction: row;
  align-items: center;
  margin: 16px auto 0 !important;
  border-radius: 15px;
}
.second-grid .barChart-container > .MuiGrid-item {
  min-width: 0;
  max-width: 100%;
}
@media (max-width: 1100px) {
  .second-grid .barChart-container > .MuiGrid-item {
    flex-basis: 100% !important;
    max-width: 100% !important;
  }
}
.second-grid .barChart-container .yearly-data-container {
  height: auto;
  flex-direction: column;
  align-content: flex-start;
  padding: 8px 0 16px;
}
.second-grid .dashboard-chart {
  height: 320px;
  min-height: 240px;
  width: 100%;
  position: relative;
}
@media (max-width: 1024px) {
  .second-grid .dashboard-chart {
    height: 260px;
  }
}

.dashboard-chart-canvas {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 220px;
}
.dashboard-chart-canvas canvas {
  width: 100% !important;
  height: 100% !important;
}

.third-grid {
  background-color: #ededed;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  justify-content: space-around;
  align-items: stretch;
  margin: 10px auto 40px;
  border-radius: 15px;
  padding: 24px 20px;
  box-sizing: border-box;
}
@media (max-width: 1200px) {
  .third-grid {
    grid-template-columns: 1fr;
  }
}
.third-grid .third-grid-similar-box {
  padding: 5px 5px;
  border-radius: 10px;
  background-color: #fff;
  column-span: 1;
  grid-row: span 1;
  display: flex;
  flex-direction: column;
}
.third-grid .third-grid-similar-box .grid-inner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  border-radius: 10px;
  padding: 0px;
  gap: 20px;
  flex: 1 1;
}
.third-grid .third-grid-similar-box .grid-inner-container .list-items {
  padding-top: 0px;
}
.third-grid .third-grid-similar-box .grid-inner-container .list-items .list-item-container {
  display: flex;
  flex-direction: row;
}
@media (max-width: 1024px) {
  .third-grid .third-grid-similar-box .grid-inner-container .list-items .list-item-container {
    flex-direction: column;
  }
}
.third-grid .third-grid-similar-box .grid-inner-container .list-items .list-item-container .list-items-text {
  color: #003478;
  font-weight: 700;
  font-size: 20px;
}
.third-grid .third-grid-similar-box .grid-inner-container .css-1p823my-MuiListItem-root {
  height: 31px;
}
@media (max-width: 1366px) and (min-width: 1200px) {
  .third-grid .third-grid-similar-box .grid-inner-container .css-1p823my-MuiListItem-root {
    height: 24px;
  }
}
@media (max-width: 1024px) {
  .third-grid .third-grid-similar-box .grid-inner-container .css-1p823my-MuiListItem-root {
    height: 48px;
  }
}
.third-grid .third-grid-other-box {
  padding: 5px 5px;
  border-radius: 10px;
  background-color: #fff;
  column-span: 1;
  grid-row: span 1;
  display: flex;
  flex-direction: column;
}
.third-grid .third-grid-other-box .grid-inner-container {
  margin-top: 0px !important;
  padding: 0px;
}
.third-grid .agent-container {
  display: flex;
  gap: 16px;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  box-sizing: border-box;
}
@media (max-width: 1024px) {
  .third-grid .agent-container {
    flex-direction: column;
    align-items: center;
  }
}
.third-grid .third-grid-other {
  width: 100%;
  display: flex;
  justify-content: center;
}
.third-grid .agent-text {
  font-size: 14px;
  font-weight: bold;
}
@media (max-width: 1024px) {
  .third-grid .agent-text {
    font-size: 15px;
  }
}
.third-grid .agent-text-value {
  font-size: 12px;
}
@media (max-width: 1024px) {
  .third-grid .agent-text-value {
    font-size: 13px;
  }
}
.third-grid .box-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
}

.profileDash {
  width: 80px;
  height: 80px;
  border-radius: 40px;
  padding: 2px;
  overflow: hidden;
}
@media (max-width: 1366px) and (min-width: 1200px) {
  .profileDash {
    width: 76px;
    height: 76px;
    border-radius: 33px;
  }
}

.avatar-dashboard .css-17o22dy-MuiAvatar-root {
  width: 70px;
  height: 70px;
  border-radius: 17px;
}
@media (max-width: 1366px) and (min-width: 1200px) {
  .avatar-dashboard .css-17o22dy-MuiAvatar-root {
    width: 70px !important;
    height: 70px !important;
  }
}
.avatar-dashboard .css-1llrwy8 {
  width: 103px;
  height: 103px;
  border-radius: 17px;
}
@media (max-width: 1366px) and (min-width: 1200px) {
  .avatar-dashboard .css-1llrwy8 {
    width: 74px !important;
    height: 74px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/style.scss"],"names":[],"mappings":"AAUA;EACE,aAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,SAAA;AATF;AAUE;EAEE,gBAAA;EACA,eAAA;AATJ;AAYE;EACE,gBAAA;AAVJ;AAYI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAVN;AAWM;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AATR;AAWM;EATF;IAUI,sBAAA;EARN;AACF;AAYE;EACE,YAAA;AAVJ;AAYI;EAHF;IAII,YAAA;EATJ;AACF;AAUI;EANF;IAOI,YAAA;EAPJ;AACF;;AAWA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AARF;AASE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAPJ;;AAWA;EAEE,YAAA;EAEA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAVF;;AAaA;EACE,aAAA;AAVF;;AAaA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,cAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;AAVF;;AAaA;EACE,aAAA;EACA,oBAAA;EACA,WAAA;EACA,8BAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;AAVF;;AAaA;EACE,UAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,UAAA;EACA,cAAA;EACA,YAAA;EACA,uBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;AAVF;;AAaA;EACE;IACE,UAAA;IACA,eAAA;EAVF;EAaA;IACE,UAAA;IACA,uBAAA;EAXF;AACF;AAcA;EACE;IACE,YAAA;IACA,iBAAA;EAZF;EAeA;IACE,yBAAA;IACA,uBAAA;EAbF;AACF;AAeA;EACE,yBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,gDAAA;EACA,SAAA;EACA,oBAAA;EACA,sBAAA;AAbF;AAeE;EAbF;IAcI,0BAAA;IACA,SAAA;EAZF;AACF;AAcE;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,2BAAA;EACA,YAAA;EACA,YAAA;AAZJ;AAcI;EACE,gBAAA;AAZN;AAgBM;EAEE,mBAAA;AAfR;AAqBE;EACE,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;AAnBJ;AAoBI;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;AAlBN;AAqBU;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAnBZ;AAqBU;EACE,aAAA;EACA,QAAA;AAnBZ;;AA2BA;EACE,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,6BAAA;EACA,mBAAA;EACA,4BAAA;EACA,mBAAA;EACA,sBAAA;AAxBF;AA0BE;EACE,wBAAA;AAxBJ;AA2BE;EACE,SAAA;EACA,iCAAA;AAzBJ;AA4BE;EACE,wBAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;EACA,oBAAA;AA1BJ;AA4BI;EACE,eAAA;EACA,eAAA;EACA,YAAA;EACA,wBAAA;AA1BN;AA8BE;EACE,qBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AA5BJ;AA+BE;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AA7BJ;AAgCE;EACE,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AA9BJ;AAgCI;EACE,YAAA;EACA,eAAA;AA9BN;AAiCI;EACE;IACE,2BAAA;IACA,0BAAA;EA/BN;AACF;AAkCI;EACE,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;AAhCN;AAoCE;EACE,aAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AAlCJ;AAoCI;EANF;IAOI,aAAA;EAjCJ;AACF;;AAqCA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAlCF;AAoCE;EACE,sBAAA;EACA,uBAAA;AAlCJ;;AAsCA;EACE,yBAAA;EACA,WAAA;EACA,aAAA;EACA,gDAAA;EACA,SAAA;EACA,6BAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;AAnCF;AAqCE;EAbF;IAcI,0BAAA;EAlCF;AACF;AAmCE;EACE,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAjCJ;AAkCI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;AAhCN;AAkCM;EACE,gBAAA;AAhCR;AAkCQ;EACE,aAAA;EACA,mBAAA;AAhCV;AAiCU;EAHF;IAII,sBAAA;EA9BV;AACF;AA+BU;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AA7BZ;AAkCM;EACE,YAAA;AAhCR;AAkCQ;EAHF;IAII,YAAA;EA/BR;AACF;AAgCQ;EANF;IAOI,YAAA;EA7BR;AACF;AAkCE;EACE,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAhCJ;AAiCI;EACE,0BAAA;EACA,YAAA;AA/BN;AAmCE;EACE,aAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,sBAAA;AAjCJ;AAmCI;EAVF;IAWI,sBAAA;IACA,mBAAA;EAhCJ;AACF;AAkCE;EACE,WAAA;EACA,aAAA;EACA,uBAAA;AAhCJ;AAmCE;EACE,eAAA;EACA,iBAAA;AAjCJ;AAoCI;EALF;IAMI,eAAA;EAjCJ;AACF;AAoCE;EACE,eAAA;AAlCJ;AAmCI;EAFF;IAGI,eAAA;EAhCJ;AACF;AAkCE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;AAhCJ;;AA6CA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AA1CF;AA2CE;EANF;IAOI,WAAA;IACA,YAAA;IACA,mBAAA;EAxCF;AACF;;AA4CE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAzCJ;AA2CI;EALF;IAMI,sBAAA;IACA,uBAAA;EAxCJ;AACF;AA2CE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AAzCJ;AA2CI;EALF;IAMI,sBAAA;IACA,uBAAA;EAxCJ;AACF","sourcesContent":["// .BarChart{\r\n//     width:833px;\r\n//     height:100px;\r\n// }\r\n\r\n// .canvas{\r\n//     width:4000px;\r\n//     height:294px;\r\n// }\r\n\r\n.grid-inner-container {\r\n  display: flex;\r\n  width: 100%;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  background-color: white;\r\n  border-radius: 10px;\r\n  padding: 15px 0;\r\n  margin-top: 10px;\r\n  gap: 20px;\r\n  flex: 1;\r\n  .list-items-text {\r\n    // color: #003478;\r\n    font-weight: 700;\r\n    font-size: 18px;\r\n  }\r\n\r\n  .list-items {\r\n    padding-top: 0px;\r\n\r\n    .list-item-container {\r\n      display: flex;\r\n      flex-direction: row;\r\n      gap: 5px;\r\n      .title {\r\n        color: #040b1e;\r\n        font-weight: 700;\r\n        font-size: 18px;\r\n      }\r\n      @media (max-width: 1024px) {\r\n        flex-direction: column;\r\n      }\r\n    }\r\n  }\r\n\r\n  .css-1p823my-MuiListItem-root {\r\n    height: 31px;\r\n\r\n    @media (max-width: 1366px) and (min-width: 1200px) {\r\n      height: 24px;\r\n    }\r\n    @media (max-width: 1024px) {\r\n      height: 48px;\r\n    }\r\n  }\r\n}\r\n\r\n.profilePic-dashboard-container {\r\n  width: 70px;\r\n  height: 70px;\r\n  overflow: hidden;\r\n  border-radius: 50%;\r\n  .profilePic-dashboard {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n  }\r\n}\r\n// .CRM_dropdown{\r\n.MuiAutocomplete-hasPopupIcon.css-1wuilmg-MuiAutocomplete-root\r\n  .MuiOutlinedInput-root {\r\n  height: 36px;\r\n  // margin:-10px;\r\n  margin-left: 1px;\r\n  background-color: #003478;\r\n  color: white;\r\n  text-align: center;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.css-1glvl0p-MuiButtonBase-root-MuiIconButton-root-MuiAutocomplete-clearIndicator {\r\n  display: none;\r\n}\r\n\r\n.main-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  margin: 0 auto;\r\n  background-color: #fff;\r\n  width: 100%;\r\n  max-width: 1400px;\r\n  min-width: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.content-container {\r\n  display: flex;\r\n  align-items: stretch;\r\n  width: 100%;\r\n  min-height: calc(100vh - 74px);\r\n  margin-top: 74px;\r\n  background-color: #fff;\r\n  box-sizing: border-box;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.dashboard-sidebar-slot {\r\n  width: 18%;\r\n  flex: 0 0 18%;\r\n  background-color: #040b1e;\r\n  align-self: stretch;\r\n}\r\n\r\n.dashboard-page {\r\n  width: 82%;\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n  padding: 16px 20px 40px;\r\n  background-color: #fff;\r\n  display: flex;\r\n  justify-content: center;\r\n  box-sizing: border-box;\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .dashboard-sidebar-slot {\r\n    width: 28%;\r\n    flex-basis: 28%;\r\n  }\r\n\r\n  .dashboard-page {\r\n    width: 72%;\r\n    padding: 12px 12px 32px;\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .dashboard-sidebar-slot {\r\n    width: 180px;\r\n    flex-basis: 180px;\r\n  }\r\n\r\n  .dashboard-page {\r\n    width: calc(100% - 180px);\r\n    padding: 12px 10px 28px;\r\n  }\r\n}\r\n.first-grid {\r\n  background-color: #ededed;\r\n  height: auto;\r\n  padding: 20px;\r\n  width: 100%;\r\n  margin: 10px auto;\r\n  border-radius: 15px;\r\n  display: grid;\r\n  grid-template-columns: repeat(3, minmax(0, 1fr));\r\n  gap: 24px;\r\n  align-items: stretch;\r\n  box-sizing: border-box;\r\n\r\n  @media (max-width: 1200px) {\r\n    grid-template-columns: 1fr;\r\n    gap: 16px;\r\n  }\r\n\r\n  .first-grid-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    justify-content: flex-start;\r\n    min-width: 0;\r\n    height: 100%;\r\n\r\n    > .grid-inner-container {\r\n      margin-top: auto;\r\n    }\r\n\r\n    .list-items-container {\r\n      .list-items {\r\n        // background-color: white;\r\n        border-radius: 10px;\r\n        // padding: 10px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .grid-inner-other {\r\n    display: flex;\r\n    align-items: flex-end;\r\n    justify-content: center;\r\n    min-width: 0;\r\n    height: 100%;\r\n    .list-items-container {\r\n      width: 100%;\r\n      display: flex;\r\n      align-items: end;\r\n      justify-content: center;\r\n      .box-container {\r\n        .list-items {\r\n          .title {\r\n            color: #040b1e;\r\n            font-weight: 700;\r\n            font-size: 18px;\r\n          }\r\n          .list-item-container {\r\n            display: flex;\r\n            gap: 5px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.second-grid {\r\n  height: auto !important;\r\n  width: 100% !important;\r\n  max-width: 100%;\r\n  justify-content: space-around;\r\n  align-items: center;\r\n  margin: 24px auto !important;\r\n  border-radius: 15px;\r\n  box-sizing: border-box;\r\n\r\n  .sales-year-title {\r\n    margin-top: 0 !important;\r\n  }\r\n\r\n  .sales-year-title h2 {\r\n    margin: 0;\r\n    font-size: clamp(18px, 2vw, 24px);\r\n  }\r\n\r\n  .dropdown-container {\r\n    display: flex !important;\r\n    flex-direction: row;\r\n    flex-wrap: wrap;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    gap: 12px;\r\n    width: 100% !important;\r\n    margin: 0 !important;\r\n\r\n    > .MuiGrid-item {\r\n      flex: 1 1 220px;\r\n      max-width: 100%;\r\n      min-width: 0;\r\n      margin-top: 0 !important;\r\n    }\r\n  }\r\n\r\n  .stat-callout {\r\n    display: inline-block;\r\n    width: min(220px, 100%);\r\n    max-width: 100%;\r\n    padding-left: 16px;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .stat-callout-value {\r\n    padding-left: 16px;\r\n    margin-top: 0;\r\n    margin-bottom: 0;\r\n    word-break: break-word;\r\n  }\r\n\r\n  .barChart-container {\r\n    height: auto !important;\r\n    width: 100% !important;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    margin: 16px auto 0 !important;\r\n    border-radius: 15px;\r\n\r\n    > .MuiGrid-item {\r\n      min-width: 0;\r\n      max-width: 100%;\r\n    }\r\n\r\n    @media (max-width: 1100px) {\r\n      > .MuiGrid-item {\r\n        flex-basis: 100% !important;\r\n        max-width: 100% !important;\r\n      }\r\n    }\r\n\r\n    .yearly-data-container {\r\n      height: auto;\r\n      flex-direction: column;\r\n      align-content: flex-start;\r\n      padding: 8px 0 16px;\r\n    }\r\n  }\r\n\r\n  .dashboard-chart {\r\n    height: 320px;\r\n    min-height: 240px;\r\n    width: 100%;\r\n    position: relative;\r\n\r\n    @media (max-width: 1024px) {\r\n      height: 260px;\r\n    }\r\n  }\r\n}\r\n\r\n.dashboard-chart-canvas {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  min-height: 220px;\r\n\r\n  canvas {\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n  }\r\n}\r\n\r\n.third-grid {\r\n  background-color: #ededed;\r\n  width: 100%;\r\n  display: grid;\r\n  grid-template-columns: repeat(3, minmax(0, 1fr));\r\n  gap: 20px;\r\n  justify-content: space-around;\r\n  align-items: stretch;\r\n  margin: 10px auto 40px;\r\n  border-radius: 15px;\r\n  padding: 24px 20px;\r\n  box-sizing: border-box;\r\n\r\n  @media (max-width: 1200px) {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  .third-grid-similar-box {\r\n    padding: 5px 5px;\r\n    border-radius: 10px;\r\n    background-color: #fff;\r\n    column-span: 1;\r\n    grid-row: span 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    .grid-inner-container {\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-items: center;\r\n      background-color: white;\r\n      border-radius: 10px;\r\n      padding: 0px;\r\n      gap: 20px;\r\n      flex: 1;\r\n\r\n      .list-items {\r\n        padding-top: 0px;\r\n\r\n        .list-item-container {\r\n          display: flex;\r\n          flex-direction: row;\r\n          @media (max-width: 1024px) {\r\n            flex-direction: column;\r\n          }\r\n          .list-items-text {\r\n            color: #003478;\r\n            font-weight: 700;\r\n            font-size: 20px;\r\n          }\r\n        }\r\n      }\r\n\r\n      .css-1p823my-MuiListItem-root {\r\n        height: 31px;\r\n\r\n        @media (max-width: 1366px) and (min-width: 1200px) {\r\n          height: 24px;\r\n        }\r\n        @media (max-width: 1024px) {\r\n          height: 48px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .third-grid-other-box {\r\n    padding: 5px 5px;\r\n    border-radius: 10px;\r\n    background-color: #fff;\r\n    column-span: 1;\r\n    grid-row: span 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    .grid-inner-container {\r\n      margin-top: 0px !important;\r\n      padding: 0px;\r\n    }\r\n  }\r\n\r\n  .agent-container {\r\n    display: flex;\r\n    gap: 16px;\r\n    width: 100%;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-wrap: wrap;\r\n    box-sizing: border-box;\r\n\r\n    @media (max-width: 1024px) {\r\n      flex-direction: column;\r\n      align-items: center;\r\n    }\r\n  }\r\n  .third-grid-other {\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n\r\n  .agent-text {\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    // color:red\r\n    // width: 46%\r\n    @media (max-width: 1024px) {\r\n      font-size: 15px;\r\n    }\r\n  }\r\n\r\n  .agent-text-value {\r\n    font-size: 12px;\r\n    @media (max-width: 1024px) {\r\n      font-size: 13px;\r\n    }\r\n  }\r\n  .box-row {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n    gap: 7px;\r\n  }\r\n  // #agent-title{\r\n  //     font-size: 13px;\r\n  //     font-weight: bold;\r\n  //     // width: 43%;\r\n  //     @media (max-width:1024px) {\r\n  //         // width: 38%\r\n  //     }\r\n\r\n  // }\r\n}\r\n\r\n.profileDash {\r\n  width: 80px;\r\n  height: 80px;\r\n  border-radius: 40px;\r\n  padding: 2px;\r\n  overflow: hidden;\r\n  @media (max-width: 1366px) and (min-width: 1200px) {\r\n    width: 76px;\r\n    height: 76px;\r\n    border-radius: 33px;\r\n  }\r\n}\r\n\r\n.avatar-dashboard {\r\n  .css-17o22dy-MuiAvatar-root {\r\n    width: 70px;\r\n    height: 70px;\r\n    border-radius: 17px;\r\n\r\n    @media (max-width: 1366px) and (min-width: 1200px) {\r\n      width: 70px !important;\r\n      height: 70px !important;\r\n    }\r\n  }\r\n\r\n  .css-1llrwy8 {\r\n    width: 103px;\r\n    height: 103px;\r\n    border-radius: 17px;\r\n\r\n    @media (max-width: 1366px) and (min-width: 1200px) {\r\n      width: 74px !important;\r\n      height: 74px !important;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
